// extracted by mini-css-extract-plugin
export default {"wrapper":"top-image-module--wrapper--56ebd","image":"top-image-module--image--11cf5"};